export default {
    language: "हिन्दी",
    StripeSuccess: {
        loading: "आपके भुगतान का प्रोसेसिंग हो रहा है...",
        successMessage: "आपकी सदस्यता सफलतापूर्वक सक्रिय हो गई है!",
        processingError: "भुगतान प्रोसेसिंग में विफल, हमसे संपर्क करें",
    },
    UserDetail: {
        userInfo: {
            emailLabel: "ईमेल",
            createdAt: "बनाया गया",
            noRecord: "कोई रिकॉर्ड नहीं",
            loginTime: "लॉगिन समय",
        },
        orders: {
            title: "ऑर्डर इतिहास",
            loading: "लोड हो रहा है...",
            refresh: "रीफ्रेश",
            orderAmount: "राशि",
            points: "पॉइंट्स",
            createdAt: "बनाया गया",
            orderType: "प्रकार",
            status: "स्थिति",
            noOrders: "कोई ऑर्डर नहीं",
            goToSubscription: "पॉइंट्स खरीदें",
            freeCredit: "मुफ्त क्रेडिट",
            paidCredit: "भुगतान किया गया क्रेडिट",
            queryOrderFailed: "ऑर्डर क्वेरी विफल",
            statusPaid: "भुगतान किया गया",
            statusPending: "लंबित",
            statusCancelled: "रद्द किया गया",
            statusDeactivated: "निष्क्रिय",
            checkoutUrlNotAvailable: "चेकआउट URL प्राप्त करने में विफल",
            verifyingPayment: "भुगतान स्थिति सत्यापित की जा रही है...",
            paymentSuccess: "भुगतान सफल",
            paymentPending: "ऑर्डर भुगतान के लिए लंबित है, कृपया भुगतान पूरा करें",
            paymentFailed: "भुगतान विफल या रद्द किया गया",
            paymentStatus: "भुगतान स्थिति",
            paymentStatusDescription: "क्या आपने भुगतान पूरा कर लिया है?",
            cancelPayment: "भुगतान रद्द करें",
            completedPayment: "भुगतान पूर्ण",
            warning: "चेतावनी",
            confirmCancelOrder: "क्या आप वाकई इस ऑर्डर को रद्द करना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती है।",
            cancel: "रद्द करें",
            confirm: "पुष्टि करें",
            cancellingOrder: "ऑर्डर रद्द किया जा रहा है...",
            orderCancelledSuccess: "ऑर्डर रद्द किया गया",
            cancelOrderFailed: "ऑर्डर रद्द करने में विफल",
            checkOrderStatusFailed: "ऑर्डर स्थिति की जांच करने में विफल",
            promptClick: "भुगतान जारी रखने के लिए \"लंबित\" स्थिति पर क्लिक करें",
        }
    },
    UserFeedback: {
        title: "उपयोगकर्ता प्रतिक्रिया",
        feedback: "हमारी AI छवि प्रसंस्करण तकनीक पर दुनिया भर के रचनाकारों और पेशेवरों से वास्तविक समीक्षाएँ सुनें।",
        people: [
            {
                id: 1,
                avatar: "feedback-user-avatar-1.jpg",
                name: "श्री लिन",
                profession: "वीडियो एडिटर और कंटेंट क्रिएटर",
                rating: 5,
                comment: "अद्भुत! ClixMagicAI अत्यंत तेज़ है! वॉटरमार्क वाले वीडियो अपलोड करें, कुछ ही मिनटों में वॉटरमार्क रहित संस्करण प्राप्त करें, बिना किसी गुणवत्ता हानि के। वॉटरमार्क हटाने के लिए एक अनिवार्य टूल!"
            },
            {
                id: 2,
                avatar: "feedback-user-avatar-2.jpg",
                name: "सुश्री सू",
                profession: "सोशल मीडिया मार्केटिंग विशेषज्ञ",
                rating: 5,
                comment: "ClixMagicAI ने मेरे इंस्टाग्राम कंटेंट लाइब्रेरी को बचा लिया! जटिल वॉटरमार्क भी सटीक रूप से पहचाने जाते हैं, किनारों का प्रसंस्करण अन्य सॉफ्टवेयर की तुलना में बहुत बेहतर है, और परिणाम अधिक प्राकृतिक दिखते हैं।"
            },
            {
                id: 3,
                avatar: "feedback-user-avatar-3.jpg",
                name: "श्री चेन",
                profession: "शॉर्ट वीडियो कंटेंट प्रोड्यूसर",
                rating: 5,
                comment: "ClixMagicAI से वॉटरमार्क हटाना बहुत आसान है, यात्रा के दौरान TikTok सामग्री प्रोसेस करें, फिर कार्यालय पहुंचकर तुरंत HD संस्करण डाउनलोड करें! यह मीडिया पेशेवरों के लिए वरदान है।"
            },
            {
                id: 4,
                avatar: "feedback-user-avatar-4.jpg",
                name: "श्री हुआंग",
                profession: "ग्राफिक डिजाइनर और विजुअल क्रिएटिव डायरेक्टर",
                rating: 5,
                comment: "एक डिजाइनर के रूप में मैं बहुत संतुष्ट हूं! क्लाइंट द्वारा प्रदान की गई लोगो वाली छवियों को संभालते समय, पृष्ठभूमि टेक्सचर को प्राकृतिक रूप से पुनर्स्थापित किया जाता है, बिना फोटोशॉप के निशान के, जिससे पोस्ट-प्रोसेसिंग का समय बचता है।"
            },
            {
                id: 5,
                avatar: "feedback-user-avatar-5.jpg",
                name: "सुश्री एमिली",
                profession: "फ्रीलांस डिजिटल कंटेंट क्रिएटर",
                rating: 5,
                comment: "एक अद्भुत खोज! सदस्यता मूल्य अन्य वॉटरमार्क हटाने वाले उत्पादों की तुलना में बहुत किफायती है, लेकिन वॉटरमार्क हटाने का प्रभाव वास्तव में बेहतर है, विशेष रूप से ग्रेडिएंट पारदर्शी वॉटरमार्क के साथ।"
            },
            {
                id: 6,
                avatar: "feedback-user-avatar-6.jpg",
                name: "श्री रॉबर्टसन",
                profession: "कॉर्पोरेट ट्रेनिंग कोर्स डेवलपर",
                rating: 5,
                comment: "ClixMagicAI को इंस्टॉल करने की आवश्यकता नहीं है, जो बहुत सुविधाजनक है! कंपनी के कंप्यूटर पर सॉफ्टवेयर इंस्टॉल करने की अनुमति नहीं है, लेकिन अब हम केवल ब्राउज़र का उपयोग करके कोर्स सामग्री प्रोसेस कर सकते हैं, कहीं भी और कभी भी।"
            },
            {
                id: 7,
                avatar: "feedback-user-avatar-7.jpg",
                name: "सुश्री झोउ",
                profession: "गृहिणी और सामुदायिक मीडिया संपादक",
                rating: 5,
                comment: "इंटरफेस इतना सरल है कि मेरी दादी भी इसका उपयोग कर सकती हैं! यदि आपके पास फोटोशॉप जैसे पेशेवर सॉफ्टवेयर सीखने का समय नहीं है, तो ClixMagicAI को आज़माएं - यह मेरे जैसे तकनीकी नौसिखिए के लिए बिल्कुल सही है! हा हा~"
            },
            {
                id: 8,
                avatar: "feedback-user-avatar-8.jpg",
                name: "श्री जॉनसन",
                profession: "ई-कॉमर्स विज़ुअल स्ट्रैटेजिस्ट",
                rating: 5,
                comment: "ClixMagicAI बहुत शक्तिशाली है, यह छवियों, वीडियो, छोटी वस्तुओं, लोगों और टेक्स्ट को हटा सकता है। इसकी सुविधाएँ व्यापक हैं, मैं इसे सभी को अनुशंसित करता हूँ~"
            },
            {
                id: 9,
                avatar: "feedback-user-avatar-9.jpg",
                name: "सुश्री फांग",
                profession: "फोटोग्राफी शौकीन और ऑनलाइन कंटेंट शेयरर",
                rating: 5,
                comment: "वाह~ आखिरकार मैंने एक ऐसा वॉटरमार्क रिमूवल टूल पाया है जो छवि गुणवत्ता को नष्ट नहीं करता! यह जादू जैसा अद्भुत है~ फोटो एडिटिंग अब समस्या नहीं है! अत्यधिक अनुशंसित!!!"
            },
            {
                id: 10,
                avatar: "feedback-user-avatar-10.jpg",
                name: "श्री विलियम्स",
                profession: "ऑनलाइन शिक्षा प्रशिक्षक",
                rating: 5,
                comment: "वॉटरमार्क स्थिति मेमोरी फीचर अत्यंत उपयोगी है! श्रृंखलाबद्ध पाठ्यक्रम वीडियो संसाधित करते समय, मुझे बार-बार चयन करने की आवश्यकता नहीं होती, जिससे कम से कम आधे घंटे का कार्य समय बचता है और मेरी शिक्षण तैयारी दक्षता में काफी वृद्धि होती है।"
            }
        ]
    },
    Order: {
        purchasePoints: "पॉइंट्स खरीदें",
        subtitle: "उच्च गुणवत्ता वाली वॉटरमार्क हटाने की सेवा के लिए उपयुक्त पॉइंट पैकेज चुनें",
        loginReminderDesc: "पॉइंट्स चुनने और खरीदने के लिए लॉगिन करें",
        freeTag: "मुफ्त",
        freePlan: "मुफ्त योजना",
        autoActivated: "लॉगिन के बाद स्वचालित रूप से सक्रिय",
        points: "पॉइंट्स",
        autoIncluded: "मुफ्त उपहार",
        discount: "छूट",
        purchase: "अभी खरीदें",
        paymentStatusDescription: "क्या आपने भुगतान पूरा कर लिया है?",
        paymentNotCompleted: "भुगतान पूरा नहीं हुआ",
        queryOrderFailed: "ऑर्डर स्थिति की जांच में विफल",
        cancelPayment: "भुगतान रद्द करें",
        completedPayment: "भुगतान पूर्ण",
        warning: "चेतावनी",
        confirmCancelOrder: "क्या आप वाकई इस ऑर्डर को रद्द करना चाहते हैं? यह क्रिया पूर्ववत नहीं की जा सकती है।",
        cancel: "रद्द करें",
        confirm: "पुष्टि करें",
        selectProductFirst: "कृपया पहले एक पैकेज चुनें",
        creatingOrder: "ऑर्डर बनाया जा रहा है...",
        orderCreated: "ऑर्डर सफलतापूर्वक बनाया गया",
        createOrderFailed: "ऑर्डर बनाने में विफल",
        checkoutUrlNotAvailable: "भुगतान लिंक प्राप्त करने में विफल",
        cancellingOrder: "ऑर्डर रद्द किया जा रहा है...",
        orderCancelledSuccess: "ऑर्डर रद्द किया गया",
        cancelOrderFailed: "ऑर्डर रद्द करने में विफल",
        verifyingPayment: "भुगतान स्थिति की जांच की जा रही है...",
        paymentSuccess: "भुगतान सफल",
        paymentPending: "ऑर्डर भुगतान के लिए प्रतीक्षित, कृपया भुगतान पूरा करें",
        paymentFailed: "भुगतान विफल या रद्द किया गया",
        checkOrderStatusFailed: "ऑर्डर स्थिति की जांच में विफल",
        quickStart: "त्वरित प्रारंभ",
        shortTerm: "अल्पकालिक उपयोग",
        recommended: "अनुशंसित",
        bestValue: "सर्वश्रेष्ठ मूल्य",
    },
    Login: {
        title: "लॉगिन",
        subtitle: "सोशल अकाउंट्स का उपयोग करके त्वरित लॉगिन",
        memberTip: "अधिक सुविधाओं का लाभ उठाने के लिए लॉगिन करें",
        types: [
            {
                id: 1,
                provider: "github",
                icon: "fab fa-github",
                desc: "GitHub अकाउंट से लॉगिन करें"
            },
            {
                id: 2,
                provider: "google",
                icon: "fab fa-google",
                desc: "Google अकाउंट से लॉगिन करें"
            }
        ],
        error: {
            serverError: "सर्वर त्रुटि, कृपया बाद में पुनः प्रयास करें",
            networkError: "नेटवर्क त्रुटि, कृपया अपने कनेक्शन की जांच करें"
        }
    },
    OAuthCallback: {
        loading: "लॉगिन अनुरोध पर प्रक्रिया की जा रही है",
        pleaseWait: "कृपया प्रतीक्षा करें, लॉगिन जानकारी का सत्यापन किया जा रहा है...",
        error: "लॉगिन विफल",
        backToHome: "होम पेज पर वापस जाएं",
        success: "लॉगिन सफल",
        redirecting: "होम पेज पर रीडायरेक्ट किया जा रहा है..."
    },
    Nav:{
        title: "ClixMagicAI",
        logo: "logo.png",
        menu: {
            pricing: "मूल्य निर्धारण",
            faq: "अक्सर पूछे जाने वाले प्रश्न",
        },
        login: "लॉगिन",
        userMenu: {
            account: "अकाउंट",
            logout: "लॉगआउट",
            credit: "पॉइंट्स",
            freeCredit: "मुफ्त",
            paidCredit: "खरीदा गया",
            nextUpdate: "पॉइंट्स का अगला अपडेट",
            language: "भाषा",
            theme: "थीम",
        },
        userMenuIcons: {
            account: "fas fa-user-circle",
            logout: "fas fa-sign-out-alt",
            credit: "fas fa-credit-card",
            language: "fas fa-globe",
            theme: "fas fa-moon",
        },
    },
    ProductAdv: {
        title: "ClixMagicAI की विशेषताएं",
        advs: [
            {
                title: "AI स्वचालित पहचान इंजन: विभिन्न हस्तक्षेपकारी तत्वों की स्वचालित पहचान",
                desc: "डीप लर्निंग एल्गोरिदम पर आधारित, यह छवियों/वीडियो में वॉटरमार्क, टेक्स्ट, चेहरे और जटिल पृष्ठभूमि तत्वों को स्वचालित रूप से पहचानता है, बिना मैनुअल मार्किंग के। इंस्टाग्राम, टिकटॉक जैसे प्लेटफॉर्म प्रारूपों का समर्थन करता है, निजी डेटा की सख्त सुरक्षा के साथ।",
                beforeImage: "adv-before-1.jpg",
                afterImage: "adv-after-1.jpg",
                click: "वॉटरमार्क हटाएं"
            },
            {
                title: "छवि शुद्धिकरण मास्टर: लोगो/दिनांक स्टैंप तुरंत हटाएं, गुणवत्ता बनाए रखें",
                desc: "ब्रांड वॉटरमार्क, शूटिंग तिथि, स्टिकर और अन्य अवांछित तत्वों को सटीक रूप से हटाता है। AI स्वचालित रूप से पृष्ठभूमि बनावट को पुनर्स्थापित करता है, प्रसंस्करण के बाद छवियां मूल जैसी प्राकृतिक दिखती हैं, सोशल मीडिया पोस्टिंग के लिए बिल्कुल उपयुक्त।",
                beforeImage: "adv-before-2.jpg",
                afterImage: "adv-after-2.jpg",
                click: "वॉटरमार्क हटाएं"
            },
            {
                title: "गतिशील वॉटरमार्क समाधान: स्क्रॉलिंग उपशीर्षक/प्लेटफॉर्म लोगो हटाएं",
                desc: "YouTube आउटट्रो बैनर, टिकटॉक गतिशील वॉटरमार्क और स्क्रॉलिंग टेक्स्ट को एक क्लिक में हटाएं। AI स्मार्ट ट्रैकिंग प्रत्येक फ्रेम को प्रोसेस करता है, सुचारू 4K उच्च गुणवत्ता वाले वीडियो आउटपुट देता है, MP4/MOV और अन्य लोकप्रिय प्रारूपों का समर्थन करता है।",
                beforeImage: "adv-before-3.jpg",
                afterImage: "adv-after-3.jpg",
                click: "वॉटरमार्क हटाएं"
            }
        ]
    },
    Description:{
        title: "ClixMagicAI",
        desc: "एक पेशेवर AI-संचालित वॉटरमार्क हटाने का टूल जो छवियों और वीडियो से वॉटरमार्क को तेजी से और आसानी से हटा देता है, प्राकृतिक परिणामों के साथ।",
        fileTypes: {
            image: 'छवि से वॉटरमार्क हटाएं',
            pdf: 'PDF से वॉटरमार्क हटाएं',
            video: 'वीडियो से वॉटरमार्क हटाएं'
        },
        marketingTags: [
            { id: "freeTrialTag", text: "दैनिक मुफ्त परीक्षण", icon: "fa-gift" },
            { id: "imageTag", text: "छवि वॉटरमार्क हटाना", icon: "fa-image" },
            { id: "videoTag", text: "वीडियो वॉटरमार्क हटाना", icon: "fa-video" },
            { id: "aiPoweredTag", text: "AI-संचालित", icon: "fa-robot" },
            { id: "noRegTag", text: "लॉगिन और उपयोग करें", icon: "fa-user-check" },
        ],
        videoPromt: "जल्द आ रहा है!",
        videoDesc: "हम वीडियो वॉटरमार्क हटाने की सुविधा विकसित कर रहे हैं जो आपको बेहतर अनुभव प्रदान करेगी।"
    },
    Footer: {
        social: {
            title: "हमसे संपर्क करें",
            logo: "logo.png",
            methods:[
                {
                    icon: "x-platform-icon",
                    link: "https://x.com/ClixMagicAI"
                },
                {
                    icon: "far fa-envelope",
                    link: "mailto:clixmagicai@gmail.com",
                    text: "clixmagicai@gmail.com"
                },
            ]
        },
        termsTitle: "कानूनी शर्तें",
        terms: [
            {
                id: 1,
                title: "गोपनीयता नीति",
                link: "/privacy"
            },
            {
                id: 2,
                title: "सेवा की शर्तें",
                link: "/terms"
            },
            {
                id: 3,
                title: "कुकी नीति",
                link: "/cookie"
            }
        ],
        copyright: "© 2025 ClixMagicAI सर्वाधिकार सुरक्षित।"
    },
    Task: {
        image: {
            imageSupportText: 'jpg, jpeg, png, webp, heic, heif फॉर्मेट्स का समर्थन, प्रति फाइल अधिकतम 10MB',
            imageFileTooLarge: 'फाइल का आकार सीमा से अधिक है (अधिकतम 10MB)',
            invalidImageType: 'असमर्थित छवि प्रारूप, कृपया JPG, JPEG, PNG, WEBP, HEIC या HEIF अपलोड करें',
            imageWillCost: 'खर्च होगा: 1 पॉइंट',
            hiecSupportText: 'HEIC/HEIF फॉर्मेट सबमिट करते समय स्वचालित रूप से PNG में परिवर्तित हो जाएंगे',
            hiecSuccess: 'HEIC/HEIF फॉर्मेट सफलतापूर्वक परिवर्तित',
            hiecFailed: 'HEIC/HEIF फॉर्मेट परिवर्तन विफल',
            processingImageTip: 'आपकी छवि प्रोसेस की जा रही है, कृपया प्रतीक्षा करें...',
            guide: {
                title: 'उपयोग गाइड',
                step1: 'छवि अपलोड करें',
                step2: 'वॉटरमार्क क्षेत्र पर ब्रश करें या मॉडल स्वचालित रूप से वॉटरमार्क पहचानेगा',
                step3: 'सबमिट पर क्लिक करें'
            }
        },
        common: {
            remaining: 'शेष पॉइंट्स',
            nextUpdate: 'पॉइंट्स का अगला अपडेट',
            handleError: 'फाइल प्रोसेसिंग में त्रुटि, कृपया अन्य फाइल का प्रयास करें',
            uploadFailed: 'फाइल अपलोड विफल',
            dragText: 'फाइल यहां खींचें या',
            clickText: 'अपलोड के लिए क्लिक करें',
            loginRequired: 'फाइल अपलोड करने के लिए कृपया लॉगिन करें',
            noRemainingTasks: 'आपके सभी पॉइंट्स समाप्त हो गए हैं',
            loginNow: 'अभी लॉगिन करें',
            upgradeNow: 'अभी पॉइंट्स खरीदें',
            taskSubmitSuccess: 'कार्य सफलतापूर्वक सबमिट किया गया',
            taskSubmitError: 'कार्य सबमिट करने में विफल',
            taskRetrySuccess: 'कार्य पुनः प्रयास सफलतापूर्वक सबमिट किया गया!',
            taskRetryError: 'कार्य पुनः प्रयास सबमिट करने में विफल!',
            processing: 'प्रोसेसिंग',
            submit: 'सबमिट',
            waiting: 'प्रतीक्षा में',
            completed: 'पूर्ण',
            failed: 'विफल',
            cancelled: 'रद्द',
            url_not_found: 'लिंक प्राप्त करने में विफल',
            deleted: 'हटाया गया',
            refreshSuccess: 'कार्य सूची रीफ्रेश की गई',
            refreshFailed: 'कार्य सूची रीफ्रेश करने में विफल',
            deleteSuccess: 'कार्य सफलतापूर्वक हटाया गया',
            deleteFailed: 'कार्य हटाने में विफल',
            waitingForCompletion: 'कृपया वर्तमान कार्य पूरा होने की प्रतीक्षा करें और फिर पुनः प्रयास करें',
            loadOriginalImageFailed: 'मूल छवि लोड करने में विफल, कृपया पुनः प्रयास करें',
            downloadFailed: 'डाउनलोड विफल',
            startingDownload: 'डाउनलोड शुरू हो रहा है...',
            noTasks: 'कोई कार्य नहीं',
            refresh: 'रीफ्रेश',
            sort: 'क्रमबद्ध करें',
            noFilterTasks: 'कोई {filter} कार्य नहीं',
            compare: 'तुलना देखें',
            originalImage: 'मूल छवि',
            processedImage: 'प्रोसेस की गई छवि',
            dragToCompare: '👈 तुलना देखने के लिए बाएं-दाएं खींचें 👉',
            cancel: "रद्द करें",
            delete: "हटाएं",
            retry: "पुनः प्रयास करें",
            download: "डाउनलोड",
            createAt: "बनाया गया",
            expiredAt: "समाप्ति तिथि",
        },
        video: {
            videoSupportText: 'mp4, mov, avi, mkv फॉर्मेट्स का समर्थन, प्रति फाइल अधिकतम 100MB',
            videoFileTooLarge: 'फाइल का आकार सीमा से अधिक है (अधिकतम 100MB)',
            invalidVideoType: 'असमर्थित वीडियो प्रारूप, कृपया MP4, MOV, AVI या MKV अपलोड करें',
            videoWillCost: 'खर्च होगा: 3 पॉइंट्स',
            processingVideoTip: 'आपका वीडियो प्रोसेस किया जा रहा है, कृपया प्रतीक्षा करें...',
            guide: {
                step1: 'वीडियो अपलोड करें',
                step2: 'वॉटरमार्क प्रकार चुनें और वॉटरमार्क क्षेत्र को सीमांकित करें',
                step3: 'सबमिट पर क्लिक करें'
            },
            annotationTools: 'वॉटरमार्क एनोटेशन टूल्स',
            selectType: 'वॉटरमार्क प्रकार चुनें',
            deleteAnnotation: 'एनोटेशन हटाएं',
            clearAllAnnotations: 'सभी एनोटेशन साफ करें',
            annotationHelp: 'एनोटेशन सहायता',
            dragTip: 'वॉटरमार्क क्षेत्र बनाने के लिए खींचें',
            resizeTip: 'वॉटरमार्क के आकार के अनुसार समायोजित करें',
            moveTip: 'बनाए गए एनोटेशन को स्थानांतरित किया जा सकता है',
            processing: 'प्रोसेसिंग',
            submit: 'सबमिट',
            taskSubmitSuccess: 'कार्य सफलतापूर्वक सबमिट किया गया',
            taskSubmitError: 'कार्य सबमिट करने में विफल',
            retryTaskTip: 'कार्य पुनः प्रयास सफलतापूर्वक सबमिट किया गया',
            retryFailed: 'कार्य पुनः प्रयास विफल',
            uploadFailed: 'अपलोड विफल',
            staticWatermarkDesc: 'स्थिर स्थान वाले स्थिर वॉटरमार्क के लिए उपयुक्त',
            normalWatermarkDesc: 'सामान्य स्थिर वॉटरमार्क के लिए उपयुक्त',
            dynamicWatermarkDesc: 'परिवर्तनशील गतिशील वॉटरमार्क के लिए उपयुक्त',
            moveWatermarkDesc: 'स्थानांतरित होने वाले वॉटरमार्क के लिए उपयुक्त'
        },
    },
    Router: {
        home: "होम",
        terms: "सेवा की शर्तें",
        privacy: "गोपनीयता नीति",
        cookie: "कुकी नीति",
        user: "उपयोगकर्ता केंद्र",
    },
    FAQ: {
        title: "ClixMagicAI उपयोग गाइड और अक्सर पूछे जाने वाले प्रश्न",
        prompt: "कोई समस्या या प्रश्न है? हमसे किसी भी समय संपर्क करें: clixmagicai@gmail.com",
        questions: [
            {
                id : 1,
                question: "ClixMagicAI क्या है और यह कैसे काम करता है?",
                answer: "ClixMagicAI एक उन्नत AI-संचालित वॉटरमार्क हटाने का टूल है। यह छवियों और वीडियो में वॉटरमार्क को स्वचालित रूप से पहचानता है, और वॉटरमार्क स्थानों को मैन्युअल रूप से चिह्नित करने का विकल्प भी प्रदान करता है। छवियों के लिए, यह कई प्रारूपों में रूपांतरण का समर्थन करता है और उच्च गुणवत्ता वाले आउटपुट की गारंटी देता है; वीडियो के लिए, यह स्थिर, गतिशील और यहां तक कि आकार बदलने वाले वॉटरमार्क को संभाल सकता है।"
            },
            {
                id : 2,
                question: "क्या ClixMagicAI मुफ्त उपयोग की पेशकश करता है?",
                answer: "हाँ, हम प्रतिदिन 10 अंकों की एक बुनियादी मुफ्त सेवा प्रदान करते हैं! आप इन्हें छवियों (प्रत्येक बार 1 अंक) या वीडियो (प्रत्येक बार 3 अंक) संसाधित करने के लिए उपयोग कर सकते हैं। वर्तमान में अतिरिक्त अंक खरीदने का समर्थन नहीं है, केवल प्रतिदिन दिए जाने वाले 10 मुफ्त अंक ही उपलब्ध हैं।"
            },
            {
                id : 3,
                question: "क्या मैं अतिरिक्त अंक खरीद सकता हूँ?",
                answer: "इस चरण में, अतिरिक्त अंक खरीदने का समर्थन नहीं है। प्रत्येक उपयोगकर्ता को प्रतिदिन केवल 10 मुफ्त अंक मिल सकते हैं, जो अगले दिन स्वचालित रूप से रीफ्रेश हो जाते हैं।"
            },
            {
                id : 4,
                question: "किन फाइल फॉर्मेट्स का समर्थन है?",
                answer: "छवियों के लिए, हम PNG, JPEG, JPG, WEBP, HEIC और HEIF फॉर्मेट का समर्थन करते हैं, जिनमें से HEIC और HEIF स्वचालित रूप से PNG में परिवर्तित हो जाएंगे। वीडियो के लिए, हम MP4, MOV सहित कई प्रारूपों का समर्थन करते हैं।"
            },
            {
                id : 5,
                question: "मेरी निजता कैसे सुरक्षित की जाती है?",
                answer: "ClixMagicAI में, हम उपयोगकर्ता की गोपनीयता को अत्यधिक महत्व देते हैं। सभी अपलोड की गई फाइलें एन्क्रिप्टेड की जाएंगी और प्रोसेसिंग पूरी होने के 24 घंटे बाद स्वचालित रूप से हटा दी जाएंगी। हम कोई भी उपयोगकर्ता फाइल या संबंधित जानकारी संग्रहीत नहीं करेंगे।"
            },
            {
                id : 6,
                question: "मैं ClixMagicAI में कैसे लॉगिन कर सकता हूं?",
                answer: "हम GitHub या Google अकाउंट के माध्यम से त्वरित लॉगिन का समर्थन करते हैं, जो आपके अकाउंट की सुरक्षा सुनिश्चित करते हुए पंजीकरण प्रक्रिया को सरल बनाता है।"
            },
            {
                id : 7,
                question: "प्रोसेसिंग कितनी तेज़ है?",
                answer: "हमारे उच्च-प्रदर्शन सर्वर और अनुकूलित AI एल्गोरिदम के कारण, अधिकांश छवि वॉटरमार्क हटाने के कार्य 10 सेकंड के भीतर पूरे हो सकते हैं, जबकि वीडियो वॉटरमार्क हटाने में कम से कम 1 मिनट लग सकता है। वास्तविक समय फाइल आकार और जटिलता के आधार पर भिन्न हो सकता है।"
            },
            {
                id : 8,
                question: "प्रोसेसिंग के बाद परिणाम कैसे होते हैं?",
                answer: "हमारे AI मॉडल को व्यापक प्रशिक्षण दिया गया है, जो छवियों और वीडियो से वॉटरमार्क को बुद्धिमानी से हटा सकता है, साथ ही मूल सामग्री की गुणवत्ता को बनाए रखता है। चाहे स्वचालित रूप से पहचाने गए या मैन्युअल रूप से चिह्नित वॉटरमार्क हों, दोनों को प्रभावी ढंग से हटाया जा सकता है, जिससे अंतिम परिणाम प्राकृतिक और निशान-रहित होता है।"
            },
            {
                id : 9,
                question: "प्रत्येक कार्य की वैधता अवधि कितनी है?",
                answer: "एक बार कार्य पूरा होने के बाद, प्रोसेस की गई फाइलें उपयोगकर्ताओं के डाउनलोड के लिए ClixMagicAI पर 24 घंटे तक रखी जाएंगी। समय सीमा समाप्त होने के बाद, आपकी गोपनीयता की रक्षा के लिए फाइलें हमारे सर्वर से स्वचालित रूप से हटा दी जाएंगी।"
            },
            {
                id : 10,
                question: "अधिकतम फाइल आकार सीमा क्या है?",
                answer: "हम अधिकतम 10MB आकार की छवि फाइलें और अधिकतम 100MB आकार की वीडियो फाइलें स्वीकार करते हैं। इस सीमा से अधिक फाइलों को अपलोड करने से पहले संपीड़ित या ट्रिम करने की आवश्यकता हो सकती है।"
            }
        ]
    },
    Terms: {
        "tabs": {
            "terms": "सेवा की शर्तें",
            "privacy": "गोपनीयता नीति",
            "cookies": "कुकी नीति"
        },
        "lastUpdated": "अंतिम अपडेट: 20 मई, 2025",
        "terms": {
            "sections": [
                {
                    "title": "1. परिचय",
                    "description": "ClixMagicAI में आपका स्वागत है। हमारी सेवाओं का उपयोग करने से आप इन सेवा शर्तों को स्वीकार करते हैं। कृपया इन्हें ध्यान से पढ़ें।"
                },
                {
                    "title": "2. सेवा का विवरण",
                    "description": "ClixMagicAI छवियों और वीडियो फाइलों से वॉटरमार्क हटाने के लिए AI-संचालित टूल प्रदान करता है। हमारी सेवाएं निम्नलिखित वैध उपयोगों के लिए हैं:",
                    "items": [
                        "अपनी सामग्री से वॉटरमार्क हटाना",
                        "ऐसी सामग्री से वॉटरमार्क हटाना जिसे संशोधित करने का आपके पास उचित अधिकार है",
                        "शैक्षिक और अनुसंधान उद्देश्यों के लिए"
                    ]
                },
                {
                    "title": "3. उपयोगकर्ता की जिम्मेदारियां",
                    "description": "ClixMagicAI का उपयोग करके, आप सहमत होते हैं:",
                    "items": [
                        "केवल वह सामग्री अपलोड करने के लिए जिसके आप मालिक हैं या जिसे संशोधित करने का आपके पास उचित अधिकार है",
                        "हमारी सेवाओं का उपयोग किसी भी अवैध उद्देश्य या किसी भी कानून का उल्लंघन करने के लिए न करने के लिए",
                        "हमारे सुरक्षा उपायों या उपयोग प्रतिबंधों से बचने का प्रयास न करने के लिए",
                        "दूसरों के बौद्धिक संपदा अधिकारों का उल्लंघन करने के लिए हमारी सेवाओं का उपयोग न करने के लिए"
                    ]
                },
                {
                    "title": "4. खाता शर्तें",
                    "description": "आपको हमारी सेवाओं की कुछ सुविधाओं का उपयोग करने के लिए एक खाता बनाने की आवश्यकता हो सकती है। लॉगिन करने के लिए, आप Google या GitHub खाते का उपयोग करना चुन सकते हैं। आप जिम्मेदार हैं:",
                    "items": [
                        "अपने खाते की सुरक्षा बनाए रखने के लिए",
                        "आपके खाते के तहत होने वाली सभी गतिविधियों के लिए",
                        "सटीक खाता जानकारी प्रदान करने के लिए (जिसमें अवतार, ईमेल, उपयोगकर्ता नाम और उपयोगकर्ता आईडी शामिल हैं, लेकिन इन्हीं तक सीमित नहीं)"
                    ]
                },
                {
                    "title": "5. मुफ्त और भुगतान सेवाएं",
                    "description": "ClixMagicAI हमारी वॉटरमार्क हटाने की सुविधाओं तक पहुंचने के लिए एक मुफ्त बेसिक कोटा और लचीले पॉइंट खरीद विकल्प प्रदान करता है:",
                    "items": [
                        "बेसिक कोटा: प्रत्येक उपयोगकर्ता को स्वचालित रूप से प्रतिदिन 10 मुफ्त पॉइंट मिलेंगे, जिन्हें सामग्री प्रोसेसिंग के लिए उपयोग किया जा सकता है",
                        "पॉइंट उपभोग नियम: छवि वॉटरमार्क हटाने से प्रति ऑपरेशन 1 पॉइंट, वीडियो वॉटरमार्क हटाने से प्रति ऑपरेशन 3 पॉइंट खर्च होते हैं",
                        "पॉइंट खरीद: आप अधिक उपयोग के लिए पॉइंट पैकेज खरीदना चुन सकते हैं, सभी खरीदे गए पॉइंट स्थायी रूप से वैध हैं, समाप्ति प्रतिबंधों के बिना",
                        "रिफंड नीति: डिजिटल सेवाओं की तत्काल और आभासी प्रकृति के कारण, सफलतापूर्वक खरीदे गए पॉइंट वापस नहीं किए जा सकते हैं"
                    ]
                },
                {
                    "title": "6. बौद्धिक संपदा अधिकार",
                    "description": "ClixMagicAI सेवा, जिसमें हमारे द्वारा बनाए गए सभी सॉफ्टवेयर, डिज़ाइन और सामग्री शामिल हैं, हमारी बौद्धिक संपदा है। आप बिना अनुमति के हमारी सेवाओं की नकल, संशोधन या व्युत्पन्न कार्य नहीं बना सकते।"
                },
                {
                    "title": "7. देयता की सीमा",
                    "description": "ClixMagicAI सेवा को 'जैसा है' प्रदान करता है, बिना किसी प्रकार की गारंटी के। हम हमारी सेवाओं के आपके उपयोग से होने वाले किसी भी नुकसान के लिए जिम्मेदार नहीं हैं।"
                },
                {
                    "title": "8. शर्तों में परिवर्तन",
                    "description": "हम किसी भी समय इन शर्तों को संशोधित कर सकते हैं। शर्तों में परिवर्तन के बाद ClixMagicAI का निरंतर उपयोग करने का अर्थ है कि आप संशोधित शर्तों को स्वीकार करते हैं।"
                },
                {
                    "title": "9. समाप्ति",
                    "description": "हम अपनी सेवाओं तक आपकी पहुंच को तुरंत समाप्त या निलंबित करने का अधिकार सुरक्षित रखते हैं, बिना पूर्व सूचना के, यदि हमें लगता है कि आपका व्यवहार इन शर्तों का उल्लंघन करता है या अन्य उपयोगकर्ताओं, हमें या तीसरे पक्ष को नुकसान पहुंचाता है।"
                },
                {
                    "title": "10. लागू कानून",
                    "description": "ये शर्तें हमारी कंपनी के पंजीकरण स्थान पर लागू कानूनों द्वारा नियंत्रित होंगी, कानूनी विरोधाभासों के प्रावधानों की परवाह किए बिना।"
                }
            ]
        },
        "privacy": {
            "sections": [
                {
                    "title": "1. परिचय",
                    "description": "ClixMagicAI में, हम आपकी गोपनीयता को महत्व देते हैं और आपके व्यक्तिगत डेटा की सुरक्षा के लिए प्रतिबद्ध हैं। यह गोपनीयता नीति बताती है कि हम आपके द्वारा हमारी वेबसाइट और सेवाओं का उपयोग करते समय आपकी जानकारी कैसे एकत्र, उपयोग और सुरक्षित करते हैं। हमारी वेबसाइट तक पहुंचकर या हमारी किसी भी सेवा का उपयोग करके, आप इस नीति में वर्णित डेटा प्रोसेसिंग प्रथाओं को स्वीकार करते हैं। हम लागू डेटा सुरक्षा नियमों का पालन करते हैं।"
                },
                {
                    "title": "2. हम जो जानकारी एकत्र करते हैं",
                    "description": "हम निम्नलिखित प्रकार की जानकारी एकत्र कर सकते हैं:",
                    "items": [
                        { "bold": "खाता जानकारी", "text": "Google या GitHub के माध्यम से लॉगिन करते समय प्रदान किया गया उपयोगकर्ता अवतार, ईमेल पता, उपयोगकर्ता नाम और उपयोगकर्ता आईडी" },
                        { "bold": "उपयोग डेटा", "text": "आप हमारी सेवाओं का उपयोग कैसे करते हैं इस बारे में जानकारी, जिसमें एक्सेस की गई सुविधाएं और उपयोग का समय शामिल है" },
                        { "bold": "अपलोड की गई सामग्री", "text": "छवियां या वीडियो जिन्हें आप प्रोसेसिंग के लिए अपलोड करते हैं" },
                        { "bold": "भुगतान जानकारी", "text": "सदस्यताओं को खरीदते समय भुगतान जानकारी (Creem/Stripe/PayPal जैसे तृतीय-पक्ष भुगतान गेटवे के माध्यम से सुरक्षित रूप से प्रोसेस की जाती है, हम केवल भुगतान स्थिति रिकॉर्ड रखते हैं)" },
                        { "bold": "तकनीकी डेटा", "text": "IP पता, ब्राउज़र प्रकार, डिवाइस जानकारी" }
                    ]
                },
                {
                    "title": "3. हम आपकी जानकारी का उपयोग कैसे करते हैं",
                    "description": "हम आपकी जानकारी का उपयोग करते हैं:",
                    "items": [
                        { "text": "हमारी सेवाओं को प्रदान करने, बनाए रखने और सुधारने के लिए" },
                        { "text": "लेनदेन को प्रोसेस और पूरा करने के लिए" },
                        { "text": "तकनीकी सूचनाएं और सहायता संदेश भेजने के लिए" },
                        { "text": "आपकी टिप्पणियों और प्रश्नों का उत्तर देने के लिए" },
                        { "text": "उपयोगकर्ता अनुभव को बेहतर बनाने के लिए उपयोग पैटर्न का विश्लेषण करने के लिए, और व्यक्तिगत डेटा को केवल सेवा के उद्देश्यों को प्राप्त करने के लिए आवश्यक सीमा तक प्रोसेस करने के लिए" },
                        { "text": "यह सुनिश्चित करने के लिए कि व्यक्तिगत डेटा के संग्रहण की अवधि आवश्यक समय से अधिक न हो" },
                        { "text": "धोखाधड़ी या अवैध गतिविधियों को रोकने के लिए" }
                    ]
                },
                {
                    "title": "4. डेटा सुरक्षा",
                    "description": "हम आपकी व्यक्तिगत जानकारी की सुरक्षा के लिए उद्योग-मानक सुरक्षा उपायों को लागू करते हैं:",
                    "items": [
                        { "text": "ट्रांसमिशन और स्टोरेज के दौरान फाइलों के लिए AES-256 एन्क्रिप्शन" },
                        { "text": "संवेदनशील डेटा को ज़ीरो-नॉलेज आर्किटेक्चर का उपयोग करके प्रोसेस किया जाता है" },
                        { "text": "दैनिक सुरक्षा लॉग ऑडिट और कमजोरी स्कैन" },
                        { "text": "कर्मचारी एक्सेस न्यूनतम विशेषाधिकार के सिद्धांत का पालन करता है" }
                    ]
                },
                {
                    "title": "5. डेटा शेयरिंग",
                    "description": "हम आपकी व्यक्तिगत जानकारी नहीं बेचते हैं। हम जानकारी साझा कर सकते हैं:",
                    "items": [
                        { "bold": "सेवा प्रदाता", "text": "विशिष्ट सेवाएं प्रदान करने के लिए आवश्यक डेटा प्रोसेसिंग तक सीमित (जैसे CloundFlare क्लाउड स्टोरेज, Creem/Stripe/PayPal जैसे तृतीय-पक्ष भुगतान गेटवे), जिन्हें डेटा प्रोसेसिंग समझौतों पर हस्ताक्षर करने की आवश्यकता होती है" },
                        { "bold": "कानूनी आवश्यकताएं", "text": "जब हम एक वैध समन, अदालत का आदेश, या हम पर लागू होने वाली अन्य कानूनी प्रक्रिया प्राप्त करते हैं" }
                    ]
                },
                {
                    "title": "6. आपके अधिकार",
                    "description": "आपके क्षेत्र में लागू कानूनों के अनुसार, आपके पास निम्नलिखित अधिकार हो सकते हैं:",
                    "items": [
                        { "text": "अपने व्यक्तिगत डेटा की एक प्रति तक पहुंच" },
                        { "text": "गलत या अपूर्ण जानकारी को सुधारना" },
                        { "text": "डेटा हटाने का अधिकार ('भूलने का अधिकार'), जब तक कि हमारे पास इसे बनाए रखने का कानूनी कारण न हो" },
                        { "text": "डेटा प्रोसेसिंग के कुछ प्रकारों का विरोध या प्रतिबंध" },
                        { "text": "डेटा पोर्टेबिलिटी का अधिकार, आप अपने डेटा के स्थानांतरण का अनुरोध कर सकते हैं" }
                    ]
                },
                {
                    "title": "7. बच्चों की गोपनीयता",
                    "description": "हमारी सेवाएं 16 वर्ष से कम आयु के नाबालिगों के लिए निर्देशित नहीं हैं। जनरल डेटा प्रोटेक्शन रेगुलेशन (GDPR) के अनुच्छेद 8 के अनुसार, 16 वर्ष से कम आयु के बच्चों की सहमति माता-पिता या अभिभावक द्वारा प्रदान की जानी चाहिए। यदि आपको पता चलता है कि 16 वर्ष से कम आयु के नाबालिग ने हमें व्यक्तिगत जानकारी प्रदान की है, तो कृपया हमें तुरंत clixmagicai@gmail.com पर संपर्क करें।"
                },
                {
                    "title": "8. इस नीति में परिवर्तन",
                    "description": "हम समय-समय पर इस गोपनीयता नीति को अपडेट कर सकते हैं। हम आपको किसी भी महत्वपूर्ण परिवर्तन के बारे में इस पृष्ठ पर नई नीति पोस्ट करके और 'अंतिम अपडेट' तारीख अपडेट करके सूचित करेंगे। महत्वपूर्ण परिवर्तनों के लिए, हम उपयोगकर्ताओं को ईमेल या अन्य प्रमुख तरीके से सूचित करेंगे।"
                },
                {
                    "title": "9. हमसे संपर्क करें",
                    "description": "यदि आपके पास इस गोपनीयता नीति के बारे में कोई प्रश्न हैं, तो कृपया हमसे clixmagicai@gmail.com पर संपर्क करें। यदि आपको लगता है कि आपके डेटा को अनुचित तरीके से प्रोसेस किया गया है या आपके पास कोई चिंता है, तो कृपया किसी भी समय हमसे संपर्क करने में संकोच न करें।"
                }
            ]
        },
        "cookies": {
            "sections": [
                {
                    "title": "1. कुकीज़ क्या हैं",
                    "description": "कुकीज़ छोटी टेक्स्ट फाइलें हैं जो वेबसाइट पर जाने पर आपके कंप्यूटर या मोबाइल डिवाइस पर रखी जाती हैं। वे वेबसाइटों को आपके डिवाइस को पहचानने और याद रखने की अनुमति देती हैं कि क्या आपने पहले साइट का दौरा किया है।"
                },
                {
                    "title": "2. हम कुकीज़ का उपयोग कैसे करते हैं",
                    "description": "ClixMagicAI कई उद्देश्यों के लिए कुकीज़ का उपयोग करता है:",
                    "items": [
                        { "bold": "आवश्यक कुकीज़", "text": "हमारी वेबसाइट की बुनियादी कार्यक्षमता के लिए आवश्यक (जैसे सत्र प्रबंधन और सुरक्षा सुविधाएं)" },
                        { "bold": "प्राथमिकता कुकीज़", "text": "आपके अनुभव को बेहतर बनाने के लिए आपकी सेटिंग्स और प्राथमिकताओं को याद रखती हैं, उदाहरण के लिए, Google या GitHub के माध्यम से लॉगिन करने के बाद आपके अवतार, उपयोगकर्ता नाम आदि को याद रखना" },
                        { "bold": "विश्लेषणात्मक कुकीज़", "text": "अनाम जानकारी एकत्र करके आगंतुक हमारी वेबसाइट के साथ कैसे बातचीत करते हैं, यह समझने में हमारी मदद करती हैं" },
                        { "bold": "मार्केटिंग कुकीज़", "text": "आपकी रुचियों से संबंधित विज्ञापन प्रदान करने के लिए आपकी ब्राउज़िंग आदतों को ट्रैक करती हैं" }
                    ]
                },
                {
                    "title": "3. हम जिस प्रकार की कुकीज़ का उपयोग करते हैं",
                    "subsection": [
                        {
                            "title": "3.1 आवश्यक कुकीज़",
                            "description": "ये कुकीज़ वेबसाइट के उचित कार्य के लिए आवश्यक हैं। वे सुरक्षा, नेटवर्क प्रबंधन और खाता पहुंच (Google और GitHub के माध्यम से लॉगिन सहित) जैसे केंद्रीय कार्यों को सक्षम करती हैं। आप इन कुकीज़ को ब्लॉक करने के लिए अपने ब्राउज़र को कॉन्फ़िगर कर सकते हैं, लेकिन वेबसाइट के कुछ हिस्से ठीक से काम नहीं कर सकते हैं।"
                        },
                        {
                            "title": "3.2 प्रदर्शन और विश्लेषण कुकीज़",
                            "description": "ये कुकीज़ अनाम जानकारी एकत्र करके आगंतुक हमारी वेबसाइट के साथ कैसे बातचीत करते हैं, यह समझने में हमारी मदद करती हैं। हम अपनी वेबसाइट और सेवाओं को बेहतर बनाने के लिए इस डेटा का उपयोग करते हैं। ये कुकीज़ ऐसी जानकारी एकत्र नहीं करतीं जो आगंतुक की पहचान कर सकती हैं।"
                        },
                        {
                            "title": "3.3 कार्यात्मकता कुकीज़",
                            "description": "ये कुकीज़ हमारी वेबसाइट को आपके द्वारा किए गए विकल्पों (जैसे भाषा प्राथमिकताएं या लॉगिन स्थिति) को याद रखने की अनुमति देती हैं ताकि बेहतर व्यक्तिगत सुविधाएं प्रदान की जा सकें, जैसे Google या GitHub के माध्यम से आपकी लॉगिन स्थिति को याद रखना।"
                        },
                        {
                            "title": "3.4 लक्ष्यीकरण और विज्ञापन कुकीज़",
                            "description": "ये कुकीज़ आगंतुकों को प्रासंगिक विज्ञापन दिखाने और हमारे विज्ञापन अभियानों की प्रभावशीलता को ट्रैक करने के लिए उपयोग की जाती हैं। कृपया ध्यान दें कि चूंकि हमारी वेबसाइट मुख्य रूप से तृतीय-पक्ष लॉगिन (Google और GitHub) पर निर्भर करती है, इस प्रकार की कुकीज़ का उपयोग मुख्य रूप से उपयोगकर्ता अनुभव को बेहतर बनाने के लिए किया जाता है, न कि प्रत्यक्ष मार्केटिंग के लिए।"
                        }
                    ]
                },
                {
                    "title": "4. कुकी प्रबंधन",
                    "description": "आप कई तरीकों से कुकीज़ को नियंत्रित और प्रबंधित कर सकते हैं। अधिकांश वेब ब्राउज़र कुकी प्राथमिकताओं को प्रबंधित करने की अनुमति देते हैं। आप कर सकते हैं:",
                    "items": [
                        { "text": "अपने डिवाइस से कुकीज़ हटाएं" },
                        { "text": "अपने ब्राउज़र की सेटिंग्स को सक्रिय करके कुकीज़ को ब्लॉक करें जो आपको कुछ या सभी कुकीज़ को अस्वीकार करने की अनुमति देती हैं" },
                        { "text": "कुकीज़ प्राप्त करते समय आपको सूचित करने के लिए अपना ब्राउज़र सेट करें" }
                    ]
                },
                {
                    "title": "5. तृतीय-पक्ष कुकीज़",
                    "description": "कुछ कुकीज़ तृतीय पक्षों द्वारा हमारी वेबसाइट पर रखी जाती हैं। इन तृतीय पक्षों में विश्लेषण सेवाएं (जैसे Google Analytics) और विज्ञापन नेटवर्क शामिल हो सकते हैं। कुकीज़ के काम करने के तरीके के कारण (कुकीज़ केवल उस पक्ष द्वारा एक्सेस की जा सकती हैं जिसने मूल रूप से उन्हें सेट किया था), हम इन तृतीय-पक्ष कुकीज़ के उपयोग को नियंत्रित नहीं करते हैं और उन्हें एक्सेस नहीं कर सकते हैं। Google और GitHub के माध्यम से लॉगिन करने वाले उपयोगकर्ताओं के लिए, हम संबंधित जानकारी से निपटने के समय इन प्लेटफॉर्म के गोपनीयता दिशानिर्देशों का पालन सुनिश्चित करेंगे।"
                },
                {
                    "title": "6. इस कुकी नीति को अपडेट करना",
                    "description": "हम समय-समय पर इस कुकी नीति को अपडेट कर सकते हैं ताकि प्रौद्योगिकी, नियमों या हमारी व्यावसायिक प्रथाओं में परिवर्तनों को प्रतिबिंबित किया जा सके। कोई भी परिवर्तन इस पृष्ठ पर पोस्ट किया जाएगा और संशोधन तिथि अपडेट की जाएगी।"
                },
                {
                    "title": "7. हमसे संपर्क करें",
                    "description": "यदि आपके पास हमारे कुकीज़ के उपयोग के बारे में कोई प्रश्न हैं, तो कृपया हमसे clixmagicai@gmail.com पर संपर्क करें।"
                }
            ]
        }
    },
}